'use strict';

const seeMoreButton = document.querySelector('.kcjo-faq__see-more');

if (seeMoreButton) {
	const label = seeMoreButton.querySelector('span');
	const hiddenItems = document.querySelectorAll('.kcjo-faq-item--hidden');

	seeMoreButton.addEventListener('click', () => {
		const isExpanded = seeMoreButton.classList.toggle('kcjo-faq__see-more--expanded');

		hiddenItems.forEach((item) => item.classList.toggle('kcjo-faq-item--hidden', !isExpanded));
		label.textContent = isExpanded ? seeMoreButton.dataset.labelLess : seeMoreButton.dataset.labelMore;
	});
}
